import { Scales as ScalesSimple, GoogleLogo, ShieldCheck, Quotes, Books, Translate } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function Login() {
    const handleLogin = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/dashboard";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="min-h-screen parchment grain relative" data-testid="login-page">
            <div className="grid md:grid-cols-2 min-h-screen">
                {/* Left column — marketing */}
                <div className="hidden md:flex flex-col justify-between p-10 lg:p-14 border-r border-border relative overflow-hidden">
                    <div
                        className="absolute inset-0 opacity-[0.08] pointer-events-none"
                        style={{
                            backgroundImage:
                                "url(https://images.pexels.com/photos/17843099/pexels-photo-17843099.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600)",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            filter: "grayscale(0.4)",
                        }}
                    />
                    <div className="relative">
                        <div className="flex items-center gap-2">
                            <ScalesSimple size={26} weight="duotone" className="text-primary" />
                            <div className="font-serif text-xl tracking-tight">CounselIQ</div>
                        </div>
                        <div className="text-[10px] mt-1 tracking-[0.3em] uppercase text-muted-foreground">
                            Advocate Workspace · Delhi · India
                        </div>
                    </div>

                    <div className="relative max-w-md space-y-6">
                        <div className="rule-line pt-2">
                            <h1 className="font-serif text-5xl leading-[1.05] tracking-tight">
                                Research, draft,
                                <br />
                                <span className="italic">and practice</span>
                                <br />
                                at court speed.
                            </h1>
                        </div>
                        <p className="text-muted-foreground text-[15px] leading-relaxed max-w-prose">
                            A focused AI workspace for Indian litigators — page-cited document analysis,
                            citation-first research, bilingual <span className="font-deva">हिन्दी</span> + English
                            voice, and formally-structured drafting.
                        </p>
                        <div className="grid grid-cols-1 gap-2 text-sm">
                            <Row icon={<Quotes weight="duotone" />} text="Citation-first research with source panel" />
                            <Row icon={<Books weight="duotone" />} text="Page-level answers from your uploaded bundle" />
                            <Row icon={<Translate weight="duotone" />} text={<>Devanagari aware — <span className="font-deva">बिलकुल</span> bilingual</>} />
                            <Row icon={<ShieldCheck weight="duotone" />} text="Privacy-preserving, audit-logged workflow" />
                        </div>
                    </div>

                    <div className="relative text-xs text-muted-foreground font-mono">
                        v0.1 · Delhi District · High Court · Supreme Court
                    </div>
                </div>

                {/* Right — Sign in */}
                <div className="flex flex-col items-center justify-center p-8 md:p-14">
                    <div className="w-full max-w-md">
                        <div className="md:hidden mb-8 flex items-center gap-2">
                            <ScalesSimple size={26} weight="duotone" className="text-primary" />
                            <div className="font-serif text-xl tracking-tight">CounselIQ</div>
                        </div>
                        <div className="rule-line pt-3 mb-2">
                            <h2 className="font-serif text-3xl tracking-tight">Sign in</h2>
                        </div>
                        <p className="text-sm text-muted-foreground mb-8">
                            Continue with your Google account. Your matters, documents, and drafts are yours alone.
                        </p>
                        <Button
                            data-testid="google-signin-btn"
                            onClick={handleLogin}
                            className="w-full h-12 bg-primary hover:bg-primary/90 text-white rounded-sm gap-3 text-base font-medium"
                        >
                            <GoogleLogo size={20} weight="bold" />
                            Continue with Google
                        </Button>

                        <div className="mt-8 border border-border rounded-sm p-4 bg-white/60">
                            <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-1">
                                Professional confidentiality
                            </div>
                            <p className="text-sm text-foreground/80 leading-relaxed">
                                Files are encrypted in transit and stored in your private workspace. Audit trail is
                                maintained for every research query, document access, and draft.
                            </p>
                        </div>

                        <p className="mt-6 text-xs text-muted-foreground">
                            By signing in you agree that this tool assists but does not replace professional legal
                            judgment. All AI-generated content requires advocate review.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

function Row({ icon, text }) {
    return (
        <div className="flex items-start gap-3">
            <div className="mt-0.5 text-primary">{icon}</div>
            <div className="text-foreground/90">{text}</div>
        </div>
    );
}
